module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading\"> <div class=col-sm-4> <h2>Business Events</h2> <ol class=breadcrumb> <li> <a ui-sref=root.home>Home</a> </li> <li class=active> <strong>Business Events</strong> </li> </ol> </div> </div> <ui-view/> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-ledger/steps/business-events.html
// module id = 2500
// module chunks = 86